// @flow
import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import SectionsTemplate from 'components/sections/SectionsTemplate';
import { type ContextRouter } from 'react-router-dom';
import SectionCurrentContainer from 'containers/sections/SectionCurrentContainer';
import SectionProductCards from 'containers/list/SectionProductCards';
import type { State } from 'store';
import { CommonActions } from 'store/actionCreators';
import type {SectionData} from 'store/modules/common';

type OwnProps = {
  section: string,
};

type Props = OwnProps & {
  selected: ?SectionData,
} & ContextRouter;

class Sections extends Component<Props> {
  initialize = async () => {
    const { section } = this.props.match.params;
    try {
      await CommonActions.getSectionInfo(section);
    } catch (e) {
      console.log(e);
      if (e && e.response && e.response.status === 404) {
        this.props.history.replace('/404');
      }
    }
  };

  componentDidMount() {
    this.initialize();
  }

  render() {
    const { selected } = this.props;
    return (selected &&
      <SectionsTemplate>
        <Helmet>
          <title>{`${selected.title} | 캐시바이`}</title>
          <meta
            name="description"
            content={`캐시바이에 등록된 ${selected.title} 섹션의 상품을 보세요.`}
          />
        </Helmet>
        <Fragment>
          <SectionCurrentContainer selected={selected} />
          <SectionProductCards products={selected.products} />
        </Fragment>
      </SectionsTemplate>
    );
  }
}

export default connect(({ common }: State) => ({
    selected: common.sections.selected,
  }), () => ({}),
)(Sections);




// WEBPACK FOOTER //
// ./src/pages/Sections.js